import { render, staticRenderFns } from "./landingRobotics-var3.vue?vue&type=template&id=4eaa7aaf&scoped=true&"
import script from "./landingRobotics-var3.vue?vue&type=script&lang=js&"
export * from "./landingRobotics-var3.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics-var3.vue?vue&type=style&index=0&id=4eaa7aaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa7aaf",
  null
  
)

export default component.exports